import _ from 'lodash';
import React from 'react';
import PropTypes, { object } from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';
import { push } from 'react-router-redux';
import { TabBar, Tab } from 'rmwc';

import * as styles from '../../styles';
import Dialog from '../../dialog/dialog';
import { renderExaminationPage } from '../examination/render';
import { setSelectedItems } from '../tree/actions';
import Tree from '../tree';
import { request } from '../../containers/actions';

import { markThisExamAsSubmited, saveExamAnswers, loadExamAnswers, savePassedTime, getPassedTimeInSecond, saveCurrentQuestionIndex, getCurrentQuestionIndex } from './online_examination_statics';
import { ServerDate, isServerLoaded } from '../../containers/ServerDate';
import StickyDrawerMenu from '../../containers/StickyDrawerMenu';
import { host, host_v2 } from '../../utilities/requests';



//@Radium 
export default class OnlineExamination extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        mode: 1,
        currentQuestion: 0,
        currentPage: 0,
        showAnswerSheet: false,
        askToFinis: false,
        initializedTimestamp: new Date().getTime(),
        gotoSecondStep: false,
        gotoSecondStepDialog: false,
        wantToGoToSecondStepDialog: false,
        disabledFinishBtn: true,
        showAlert: false,
        timerColor: "#000000",
        timerBackColor: "",
        firstTimeAlert: false
    };

    constructor(props, context) {
        super(props, context);
        this.submit = this.submit.bind(this);
        this.checkTime = this.checkTime.bind(this);
        this.renderPage = this.renderPage.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.fetch = this.fetch.bind(this);
        this.saveExamCurrentStatus = this.saveExamCurrentStatus.bind(this);

    }

    async componentDidMount() {
        StickyDrawerMenu.hide();
        this.mounted = true;
        this.setState({ initializedTimestamp: new Date().getTime() - 1000 * getPassedTimeInSecond(this.props.params.examinationId) });


        clearInterval(this.interval);
        this.interval = setInterval(this.checkTime.bind(this), 1000);
        await this.fetch();


        if (this.mounted)
            this.setCurrentQuestion(getCurrentQuestionIndex(this.props.params.examinationId));


        var cachedAns = loadExamAnswers(this.props.params.examinationId);
        if (cachedAns !== null)
            this.setState({ answers: cachedAns });
    }



    saveExamCurrentStatus() {
        setTimeout(() => {
            saveExamAnswers(this.props.params.examinationId, this.state.answers);
        }, 1);
    }

    componentWillUnmount() {
        this.mounted = false;
        clearInterval(this.interval);
        StickyDrawerMenu.show();
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.store.getIn(['materialsTree', 'selected']) !== this.props.store.getIn(['materialsTree', 'selected']) &&
            nextProps.store.getIn(['materialsTree', 'selected']).size > 0
        ) {
            const materialId = Number(nextProps.store.getIn(['materialsTree', 'selected']).keySeq().first());
            const questions = _.filter(this.state.examination.questions, 'question_id');
            const question = _.find(_.sortBy(questions, 'index'), { materialId });
            question.index = getCurrentQuestionIndex(this.props.params.examinationId);
            if (this.state.mode === 1)
                this.setCurrentQuestion(question.index);
            else
                this.setCurrentPage(question.page);
            this.context.store.dispatch(setSelectedItems(
                [],
                'online-examination-material',
                this.props.store.getIn(['materialsTree', 'elementId']),
            ));
        }
    }

    setCurrentQuestion(index) {
        document.getElementById('scrollQuestion')?.scrollTo(0, 0);
        this.setState({
            currentQuestion: index,
            currentPage: this.state.examination.questions[index].page,
            index: (index + 1).persian(),
        });
        saveCurrentQuestionIndex(this.props.params.examinationId, index);
    }

    setCurrentPage(page) {
        this.setState({
            currentQuestion: _.find(this.state.examination.questions, { page }).index,
            currentPage: page,
            index: (page + 1).persian(),
        });
    }
    // this is fetch and respons (the variable)
    async fetch() {
        let url = `/examination/${this.props.params.examinationId}/?detailed&react__route=${window.location.pathname}`;
        const response = await this.context.store.dispatch(request(url));
        //console.log("mount :" , this.mounted);
        if (!this.mounted)
            return;

        if (response.end == null)
            response.end = (ServerDate().getTime() + 1000 * 60 * 60 * 24 * 365) / 1000;
        // response.end = (new Datetime().getTime() + 1000 * 60 * 60 * 24 * 365) / 1000;

        this.setState({
            examination: {
                ...response,
                questions: _.map(response.questions, question => ({
                    ...question,
                    material: question.subjects && (question.subjects.length ? question.subjects[0].parent_material : ''),
                    materialId: question.subjects && (question.subjects.length ? question.subjects[0].parent_material_id : ''),
                })),
            },

            index: '1'.persian(),
            answers: _.map(Array(response.questions.length), _.constant(0)),
            showAnswerSheet: false,
            askToFinis: false,
            currentQuestion: getCurrentQuestionIndex(this.props.params.examinationId),
            disabledFinishBtn: response.first_question_count > 0,
        });
    }
    // this is all reasoen that why give me a 500 http  internal server error
    async submit() {
            try{
                    // if (this.state.isSendig) return;

            clearInterval(this.interval);
            this.setState({ isSendig: true });
            const payload = {
                answers: this.state.answers,
                examination: { id: this.state.examination.id },
                analyze: true,
                headers: { 'content-type': 'application/json' },
            };
            await this.context.store.dispatch(request({
                path: '/multiple-choice-paper/',
                body: payload,
                data: JSON.stringify(payload),
                method: 'POST',
                headers: { 'content-type': 'application/json' },
            }, null, 0, this.onDone.bind(this), this.onError.bind(this)));

            // زمان اتمام آزمون
            const body = {
                examId: this.state.examination.id,
                start: false
            };
            const token = this.context.store.getState().getIn(['application', 'token']);
            const res = await fetch(host + '/api/exam_date_log/', {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
                }
            });
            await res.json();
            // زمان اتمام آزمون
            // await this.context.store.dispatch(request({
            //     path: `/exam_date_log/`,
            //     body: {
            //         examId: this.state.examination.id,
            //         start : false
            //     },
            // }));
            return true;
            }
            catch (error) {
            // مدیریت خطا
            this.setState({ isSendig: false });
            return false; // در صورت شکست
        }
    }

    onError(errorText = null) {
        if (errorText == null) {
            alert('ارسال پاسخبرگ با خطا مواجه شد. دسترسی به اینترنت را بررسی و مجدد تلاش کنید.');
            this.setState({ isSendig: false });
        }
        else {
            //user have sent the answers earlier
            this.context.store.dispatch(push(this.props.urls.report.format(this.props.params)));
        }
    }

    onDone(status) {
        markThisExamAsSubmited(this.state.examination.id);;
        this.context.store.dispatch(push(this.props.urls.report.format(this.props.params)));
    }

    updated_unrestricted_duration() {
        return this.state.examination.unrestricted_duration;
    }


    showTimer() {
        // debugger;
        // var xmlHttp;
        // function srvTime(){
        //     try {
        //         //FF, Opera, Safari, Chrome
        //         xmlHttp = new XMLHttpRequest();
        //     }
        //     catch (err1) {
        //         //IE
        //         try {
        //             xmlHttp = new ActiveXObject('Msxml2.XMLHTTP');
        //         }
        //         catch (err2) {
        //             try {
        //                 xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
        //             }
        //             catch (eerr3) {
        //                 //AJAX not supported, use CPU time.
        //                 alert("AJAX not supported");
        //             }
        //         }
        //     }
        //     xmlHttp.open('HEAD',window.location.href.toString(),false);
        //     xmlHttp.setRequestHeader("Content-Type", "text/html");
        //     xmlHttp.send('');
        //     // var dateServer = new Date(xmlHttp.getResponseHeader("Date"));
        //     var dateServer = xmlHttp.getResponseHeader("Date");
        //     debugger;
        //     // var utcDateServer = dateServer.setHours(dateServer.getHours() + 3.5);
        //     // return utcDateServer;
        //     return dateServer;
        // } 
        //   var st = srvTime();
        //   debugger;

        // var serverDate = ServerDate().getTime();
        var serverDate = new Date().getTime();
        // debugger;
        var initTime = this.state.initializedTimestamp;
        var checker = (serverDate - initTime) / 1000;
        var firstDuration = this.state.examination.first_duration * 60;
        var res = Math.max(0,
            Math.min(
                // (new Date(this.state.examination.end * 1000).getTime() - new Date().getTime()) / 1000 - 15
                (new Date(this.state.examination.end * 1000).getTime() - ServerDate().getTime()) / 1000 - 15
                ,
                Math.floor((checker) < firstDuration
                    ? (firstDuration -
                        Math.floor(checker)) :
                    (this.updated_unrestricted_duration() * 60 -
                        Math.floor(checker))
                )
            ));

        if (this.state.examination.first_question_count > 0) {
            if (res <= 240) {
                this.setState({
                    timerColor: styles.alertColor,
                    timerBackColor: styles.alertBackColor,
                    firstTimeAlert: this.state.currentQuestion + 1 <= this.state.examination.first_question_count
                });
            }
            else {
                this.setState({
                    timerColor: "#000000",
                    timerBackColor: "",
                    firstTimeAlert: false
                });
            }

        }

        return res.timerFormat();
    }

    async checkTime() {
        var passedTimeInSecond = (new Date().getTime() - this.state.initializedTimestamp) / 1000;
        savePassedTime(this.props.params.examinationId, passedTimeInSecond);
        saveCurrentQuestionIndex(this.props.params.examinationId, this.state.currentQuestion);
        if (
            this.state.examination &&
            (
                (
                    isServerLoaded() &&
                    ((new Date(this.state.examination.end * 1000).getTime() - ServerDate().getTime()) / 1000 - 15) <= 0
                )
                ||
                (
                    this.updated_unrestricted_duration() * 60 -
                    Math.floor(passedTimeInSecond) <= 0
                )
            )
        ) {
           

            const isSuccess = await this.submit();
            if (isSuccess) {
                alert("زمان آزمون به پایان رسید و پاسخ‌های شما با موفقیت ثبت شد.");
                // کدهای مربوط به انتقال کاربر به صفحه دیگر (در صورت نیاز)
            }
            else {
                alert("خطا در ثبت آزمون، لطفا دوباره تلاش کنید.");
            }
            // alert("زمان آزمون پایان یافت. پاسخ نامه شما ارسال شد.");
        }
        //check two step exam

        if (this.state.examination == undefined) {
            console.log("Kill timer");
            return;
        }

        var first_duration = this.state.examination.first_duration;
        var avoid = false;
        if (first_duration != 0) {
            var current_time = (
                this.updated_unrestricted_duration() * 60 -
                Math.floor((new Date().getTime() - this.state.initializedTimestamp) / 1000)
            );

            var main_time = this.updated_unrestricted_duration() * 60;

            var first_step = first_duration * 60;

            var allowed_time_first = main_time - first_step;

            avoid = current_time < allowed_time_first;
            if (this.state.gotoSecondStep === false && avoid) {
                this.setState({
                    gotoSecondStep: true
                });
                if (allowed_time_first - 15 < current_time) {
                    // alert('مدت زمان پاسخدهی به سوالات دفترچه شماره (1) به پایان رسیده و وارد دفترچه شماره (2) خواهید شد');
                    this.setState({
                        showAlert: true
                    });
                }
                this.setCurrentQuestion(this.state.examination.first_question_count);

            }
        }



        this.forceUpdate();
    }

    next_question(val) {

        var first_question_count = this.state.examination.first_question_count;

        // age kolan tafkiki nabod 
        if (first_question_count === 0) {
            if (this.state.mode === 1) {
                this.setCurrentQuestion(val);
            }
            else {
                this.setCurrentPage(val);
            }
        }
        else {
            var first_duration = this.state.examination.first_duration;
            var second_duration = this.state.examination.second_duration;
            var avoid = false;
            if (first_duration != 0) {

                if (val > first_question_count) {
                    this.setState({
                        disabledFinishBtn: false,
                        showAlert: false
                    })
                }

                var current_time = (
                    this.updated_unrestricted_duration() * 60 -
                    Math.floor((new Date().getTime() - this.state.initializedTimestamp) / 1000)
                );

                var main_time = this.updated_unrestricted_duration() * 60;

                var first_step = first_duration * 60;

                var allowed_time_first = main_time - first_step;

                avoid = current_time < allowed_time_first;
            }


            if (this.state.mode === 1) {
                // check kardan zaman pasokhdehi be bakhsh aval
                if (val <= first_question_count && avoid) {
                    this.setState({
                        gotoSecondStepDialog: true,
                        gotoSecondStep: true
                    });
                    this.setCurrentQuestion(first_question_count);
                }
                else {
                    if (val <= first_question_count && (val + 1) > first_question_count) {
                        // agar zodtar khast bere be bakhsh badi
                        // if (window.confirm('سوالات دفترچه شماره (1) به پایان رسیده ، در صورت رفتن به سوال بعدی دیگر قادر به مشاهده و تغییر سوالات قبلی نخواهید بود')) {
                        //     this.setCurrentQuestion(val);
                        // }
                        this.setState({
                            wantToGoToSecondStepDialog: true,
                        });
                    }
                    else {
                        this.setCurrentQuestion(val);
                    }
                }

            }
            else {
                this.setCurrentPage(val);
            }

        }
    }
    previous_question(val) {
        var first_question_count = this.state.examination.first_question_count;

        // age tafkiki nabod
        if (first_question_count === 0) {
            if (this.state.mode === 1) {
                this.setCurrentQuestion(val);
            }
            else {
                this.setCurrentPage(val);
            }
        }
        else {
            if (this.state.mode === 1) {
                // nazare bargarde be bakhshe aval
                if (first_question_count !== 0 && val + 1 === first_question_count) {
                    alert('امکان مشاهده سوالات دفترچه شماره (1) وجود ندارد');
                }
                else {
                    this.setCurrentQuestion(val);
                }

            }
            else {
                this.setCurrentPage(val);
            }
        }


    }

    click_answer_on_sheet(column, row, questions) {

        this.setState({
            showAnswerSheet: false,
            askToFinis: false
        });

        var first_question_count = this.state.examination.first_question_count;
        var flag = false;
        var currentQuestion = this.state.currentQuestion + 1;
        var gotoIndex = column * 30 + row;

        if (first_question_count > 0) {
            if (currentQuestion <= first_question_count) {
                if (gotoIndex + 1 <= first_question_count) {
                    flag = true;
                }
            }
            else {
                if (gotoIndex + 1 > first_question_count) {
                    flag = true;
                    this.setState({
                        disabledFinishBtn: false
                    })
                }
            }
        }
        else {
            flag = true;
        }

        if (flag) {
            if (this.state.mode === 1) {

                this.setCurrentQuestion(gotoIndex);
            }
            else
                this.setCurrentPage(questions[column * 30 + row].page);
        }

    }

    renderPage() {
        if (this.state.mode === 1) {
            const question = _.find(this.state.examination.questions, { index: this.state.currentQuestion });
            if (!question)
                return null;
            return <div>
                {window.gettext('Question')}&nbsp;{(this.state.currentQuestion + 1).persian()}
                <div
                    style={{
                        width: question.width + 'cm',
                        height: question.height + 'cm',
                        padding: this.state.examination.layout.padding + 'cm',
                        boxSizing: 'border-box',
                        ...styles.content,
                    }}
                    dangerouslySetInnerHTML={{ __html: question.content }}
                />
            </div>;
        }
        else {
            return renderExaminationPage(this.state.examination, this.state.currentPage);
        }
    }

    renderOptions() {
        if (this.state.mode === 1) {
            return <div
                style={{
                    marginTop: '.5em',
                    direction: 'ltr',
                    paddingLeft: '2em',
                    paddingTop: '.5em',
                    paddingBottom: '.5em',
                }}>
                <div style={{ display: 'inline-block', width: '1.5em' }}>
                    {(this.state.currentQuestion + 1).persian()}.
                </div>
                <span style={{ userSelect: 'none' }}>
                    {_.map(Array(this.state.examination.questions[this.state.currentQuestion].options ?? 4), (__, option) => <div
                        key={option}
                        style={{
                            width: '25px',
                            height: '14px',
                            marginLeft: '.8em',
                            border: '.0625em solid black',
                            borderRadius: '.4em',
                            boxSizing: 'border-box',
                            backgroundColor: this.state.answers[this.state.currentQuestion] & 1 << option ? 'rgba(0, 0, 0, .6)' : 'white',
                            color: 'rgba(0, 0, 0, .6)',
                            fontSize: '.9em',
                            textAlign: 'center',
                            lineHeight: '1',
                            display: 'inline-block',
                            cursor: 'pointer',
                        }}
                        onClick={event => {
                            this.setState(update(this.state, {
                                answers: {
                                    $splice: [[
                                        this.state.currentQuestion,
                                        1,
                                        event.shiftKey
                                            ? this.state.answers[this.state.currentQuestion] ^ 1 << option
                                            : this.state.answers[this.state.currentQuestion] & 1 << option
                                                ? this.state.answers[this.state.currentQuestion] ^ 1 << option
                                                : 1 << option,
                                    ]]
                                }
                            }))

                            this.saveExamCurrentStatus();
                        }}>
                        {(option + 1).persian()}
                    </div>)}
                </span>
            </div>;
        }
        else {
            const questions = _.filter(_.filter(this.state.examination.questions, { page: this.state.currentPage }), 'question_id');
            return <div
                style={{
                    marginTop: '.5em',
                    paddingLeft: '2em',
                    paddingTop: '.5em',
                    paddingBottom: '.5em',
                }}>
                {_.map(questions, question => <div
                    key={question.id}
                    style={{
                        width: '100%',
                        marginBottom: '.5em',
                        direction: 'ltr',
                    }}>
                    <div style={{ display: 'inline-block', width: '1.5em' }}>
                        {(question.index + 1).persian()}.
                    </div>
                    {_.map(Array(question.options), (__, option) => <div
                        key={option}
                        style={{
                            width: '25px',
                            height: '14px',
                            marginLeft: '.8em',
                            border: '.0625em solid black',
                            borderRadius: '.4em',
                            boxSizing: 'border-box',
                            backgroundColor: this.state.answers[question.index] & 1 << option ? 'rgba(0, 0, 0, .6)' : 'white',
                            color: 'rgba(0, 0, 0, .6)',
                            fontSize: '.9em',
                            textAlign: 'center',
                            lineHeight: '1',
                            display: 'inline-block',
                            cursor: 'pointer',
                        }}
                        onClick={event => {
                            this.setState(update(this.state, {
                                answers: {
                                    $splice: [[
                                        question.index,
                                        1,
                                        event.shiftKey
                                            ? this.state.answers[question.index] ^ 1 << option
                                            : this.state.answers[question.index] & 1 << option
                                                ? this.state.answers[question.index] ^ 1 << option
                                                : 1 << option,
                                    ]],
                                }
                            }));
                            this.saveExamCurrentStatus();
                        }}>
                        {(option + 1).persian()}
                    </div>)}
                </div>)}
            </div>;
        }
    }

    render() {
        if (!this.state.examination || !this.mounted)
            return null;

        const questions = _.filter(this.state.examination.questions, 'question_id');//_.filter(this.state.examination.questions, 'key');//Why you are controlling keys??? why??
        const materials = _.uniq(_.map(
            _.filter(questions, 'material'),
            question => ({ id: question.materialId, label: question.material }),
        ), 'id');
        let previous = this.state.mode === 1 ? this.state.currentQuestion - 1 : this.state.currentPage - 1;
        let next = this.state.mode === 1 ? this.state.currentQuestion + 1 : this.state.currentPage + 1;
        if (this.state.mode === 1) {
            while (previous > 0 && !questions[previous])
                previous--;
            while (next < questions.length && !questions[next])//.key why do you need to check questions key for next and previus buttons
                next++;
        }
        return <div
            ref='container'
            style={this.state.fullscreen
                ? {
                    // padding: '2em',
                    width: '100%',
                    height: '100%',
                    boxSizing: 'border-box',
                    backgroundColor: 'white'
                }
                : {
                    paddingLeft: '3%',
                    paddingRight: '3%',
                    // paddingLeft: '.5em',
                    // paddingRight: '.5em',
                    height: 'calc(100% - .5em)',
                }
            }>
            {
                this.state.showAlert ?
                    <div style={{
                        color: styles.alertColor,
                        backgroundColor: styles.alertBackColor,
                        borderColor: styles.alertBorderColor,
                        marginBottom: "10px",
                        padding: "10px"
                    }}>

                        مدت زمان پاسخدهی به سوالات دفترچه شماره (1) به پایان رسیده و وارد دفترچه شماره (2) شدید

                    </ div> : null
            }
            {
                this.state.firstTimeAlert ?
                    <div style={{
                        color: styles.alertColor,
                        backgroundColor: styles.alertBackColor,
                        borderColor: styles.alertBorderColor,
                        marginBottom: "10px",
                        padding: "10px"
                    }}>

                        زمان پاسخ به دفترچه شماره (1) در حال اتمام است

                    </div> : null
            }
            <Dialog isOpen={this.state.showAnswerSheet || this.state.askToFinis || this.state.gotoSecondStepDialog || this.state.wantToGoToSecondStepDialog}>
                <div style={{ display: 'inline-block', width: '100%', direction: 'ltr', padding: '.5em' }}>
                    {this.state.askToFinis ? <div>آیا میخواهید به آزمون پایان دهید؟ در صورت ارسال پاسخ نامه، امکان شروع مجدد آزمون وجود نخواهد داشت.</div> : null}
                    {_.map(Array(Math.ceil(questions.length / 30)), (value, column) => <div
                        key={column}
                        style={{
                            float: 'left',
                            marginRight: '2em',
                            lineHeight: '1em',
                        }}>
                        {_.map(Array(Math.min(questions.length - column * 30, 30)), (value, row) => <div
                            key={row}
                            style={{
                                display: 'inline-block',
                                float: 'left',
                                clear: 'both',
                                cursor: 'pointer',
                                color: 'rgba(0, 0, 0, .6)',
                            }}
                            onClick={() => this.click_answer_on_sheet(column, row, questions)}>
                            <div
                                style={{
                                    width: '2em',
                                    float: 'left',
                                    marginTop: '.06em',
                                    marginBottom: '-.07em',
                                    fontSize: '.85em',
                                }}>
                                {(column * 30 + row + 1).persian()}.
                            </div>
                            {questions[column * 30 + row]//.key
                                ? _.map(Array(questions[column * 30 + row].options ?? 4), (value, option) => <div
                                    key={option}
                                    style={{
                                        width: '16px',
                                        height: '11px',
                                        margin: '.2em',
                                        float: 'left',
                                        border: '.0625em solid rgba(0, 0, 0, .6)',
                                        borderRadius: '.3em',
                                        boxSizing: 'border-box',
                                        backgroundColor: this.state.answers[column * 30 + row] & (1 << option) ? 'rgba(0, 0, 0, .6)' : 'white',
                                        fontSize: '.8em',
                                        textAlign: 'center',
                                        lineHeight: '1',
                                    }}>
                                    {(option + 1).persian()}
                                </div>)
                                : null
                            }
                        </div>)}
                    </div>)}
                    {this.state.askToFinis ? <div style={{ float: 'right' }}>
                        <button
                            // this is the back alert
                            style={{ ...styles.button, float: 'left', marginBottom: '.5em', marginRight: '.5em' }}
                            onClick={() => { this.setState({ showAnswerSheet: false, askToFinis: false }); }
                            }>
                            {window.gettext('Back')}
                        </button>
                        <button
                            className='king55'
                            style={{
                                ...styles.defaultButton,
                                float: 'left',
                                marginBottom: '.5em',
                                marginRight: '.5em',
                                backgroundColor: styles.fourthColor,
                                opacity: this.state.isSendig ? 0.5 : 1,
                                pointerEvents: this.state.isSendig ? 'none' : 'auto',
                            }}



                            // this is .....
                            onClick={() => {

                                //let confirmed = window.confirm("آیا میخواهید با آزمون پایان دهید؟ (درصورت ارسال پاسخ امکان تغییر وجود ندارد) ");

                                //if (confirmed) 
                                //{
                                this.submit();
                                //}
                                this.setState({ showAnswerSheet: false, askToFinis: false })

                                //this is..


                            }
                            }
                        >

                            پایان آزمون و ارسال
                        </button></div> : null}

                    {this.state.gotoSecondStepDialog ? <div style={{ direction: 'rtl' }}>
                        <div>

                            مدت زمان پاسخدهی به سوالات دفترچه شماره (1) به پایان رسیده و وارد دفترچه شماره (2) خواهید شد
                        </div>
                        <div style={{ float: 'right', width: '100%', display: 'flex' }}>
                            <button
                                className='king55'
                                style={{
                                    ...styles.defaultButton,
                                    float: 'left',
                                    marginBottom: '.5em',
                                    marginRight: '.5em',
                                    backgroundColor: styles.fourthColor,
                                    opacity: this.state.isSendig ? 0.5 : 1,
                                    pointerEvents: this.state.isSendig ? 'none' : 'auto'
                                }}
                                onClick={() => { this.setState({ gotoSecondStepDialog: false }); }
                                }>
                                متوجه شدم
                            </button>
                        </div>
                    </div> : null}


                    {this.state.wantToGoToSecondStepDialog ? <div style={{ direction: 'rtl' }}>
                        <div>

                            سوالات دفترچه شماره (1) به پایان رسیده ، در صورت رفتن به سوال بعدی دیگر قادر به مشاهده و تغییر سوالات قبلی نخواهید بود
                        </div>
                        <div style={{ float: 'right', width: '100%', display: 'flex' }}>
                            <button
                                // this is the back alert
                                style={{ ...styles.button, float: 'left', marginBottom: '.5em', marginRight: '.5em' }}
                                onClick={() => { this.setState({ wantToGoToSecondStepDialog: false }); }
                                }>
                                {window.gettext('Back')}
                            </button>
                            <button
                                className='king55'
                                style={{
                                    ...styles.defaultButton,
                                    float: 'left',
                                    marginBottom: '.5em',
                                    marginRight: '.5em',
                                    backgroundColor: styles.fourthColor,
                                    opacity: this.state.isSendig ? 0.5 : 1,
                                    pointerEvents: this.state.isSendig ? 'none' : 'auto'
                                }}
                                onClick={() => {
                                    this.setState({ wantToGoToSecondStepDialog: false, gotoSecondStep: true });

                                    var newInitializedTimestamp = new Date().getTime() - this.state.examination.first_duration * 60 * 1000;
                                    var initializedTimestamp = Math.min(this.state.initializedTimestamp, newInitializedTimestamp);
                                    this.setState({ initializedTimestamp: initializedTimestamp });
                                    var passedTimeInSecond = (new Date().getTime() - initializedTimestamp) / 1000;
                                    savePassedTime(this.props.params.examinationId, passedTimeInSecond);
                                    this.setCurrentQuestion(this.state.examination.first_question_count);
                                }
                                }>
                                قبول دارم
                            </button>
                        </div>
                    </div> : null}

                </div>
                <i
                    style={{ float: 'right', cursor: 'pointer' }}
                    className='fa-times fa-lg'
                    onClick={() => this.setState({ showAnswerSheet: false, askToFinis: false })}>
                </i>
            </Dialog>
            <button
                // this is the back alert
                style={{ ...styles.button, float: 'left', marginBottom: '.5em', marginRight: '.5em' }}
                onClick={() => {

                    let confirmed = window.confirm(" آیا میخواهید خارج شوید؟ ");

                    if (confirmed) {
                        if (document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen) {
                            (
                                document.exitFullScreen ||
                                document.webkitExitFullscreen ||
                                document.mozCancelFullScreen ||
                                document.msExitFullScreen
                            ).bind(document)();
                            this.setState({ fullscreen: false });
                            return;
                        }

                        this.context.store.dispatch(push('/reports/multiple-choice/'));
                    }
                }

                }>
                {window.gettext('Back')}
            </button>
            <button
                className='king55'
                disabled={this.state.disabledFinishBtn}
                style={{
                    ...styles.defaultButton,
                    float: 'left',
                    marginBottom: '.5em',
                    marginRight: '.5em',
                    color: next < (this.state.mode === 1 ? questions.length : _.maxBy(questions, 'page')?.page + 1) ? 'black' : 'white',
                    backgroundColor: this.state.disabledFinishBtn ? styles.disabledColor : next < (this.state.mode === 1 ? questions.length : _.maxBy(questions, 'page')?.page + 1) ? 'white' : styles.fourthColor,
                    opacity: this.state.isSendig ? 0.5 : 1,
                    pointerEvents: this.state.isSendig ? 'none' : 'auto'
                }}



                // this is .....
                onClick={() => {
                    this.setState({ askToFinis: true });
                }
                }
            >

                پایان آزمون و ارسال
            </button>
            {

            }

            <button
                style={{
                    ...styles.button,
                    float: 'left',
                    marginBottom: '.5em',
                    marginRight: '.5em',
                    minWidth: undefined,
                    width: '2.65em',
                    height: '2.65em',
                }}

                onClick={() => {

                    if (document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen) {
                        (
                            document.exitFullScreen ||
                            document.webkitExitFullscreen ||
                            document.mozCancelFullScreen ||
                            document.msExitFullScreen
                        ).bind(document)();
                        this.setState({ fullscreen: false });
                    }
                    else {
                        (
                            this.refs.container.requestFullScreen ||
                            this.refs.container.webkitRequestFullScreen ||
                            this.refs.container.mozRequestFullScreen ||
                            this.refs.container.msRequestFullScreen
                        ).bind(this.refs.container)();
                        this.setState({ fullscreen: true });
                    }
                }}>
                <i className='fa-arrows-alt fa-lg'></i>
            </button>




            <span
                className='hover'
                style={{

                    marginRight: '.5em',
                    marginLeft: '2.5em',
                    marginBottom: '.5em',
                    float: 'left',
                    fontSize: '1.3em',
                    textAlign: 'left',
                    display: 'inline-block',
                    width: '50px'
                }}
                onTouchStart={
                    () => { /*$(".hover").css({ 'cursor': 'pointer' })*/ }//TODO
                }

                onClick={() => this.setState({ reversedTimer: this.state.reversedTimer.defaultValue = true })}
            >
                {
                    this.state.examination == null
                        ?
                        <span>
                            {((Math.floor(((new Date()).getTime() - this.state.initializedTimestamp) / 1000))).timerFormat()}
                        </span>
                        :
                        <span style={{ color: this.state.timerColor, backgroundColor: this.state.timerBackColor, padding: "5px" }}>
                            {
                                this.showTimer()
                            }
                        </span>
                }
            </span>

            <div style={{ float: 'right', minHeight: '50%', maxWidth: '94vw', }}>{/*width: '22cm',*/}
                <div style={{ float: 'right', marginTop: '.5em', marginBottom: '1.5em' }}>
                    {window.gettext('Examination view style')}:&nbsp;
                </div>
                <Radium.Style
                    rules={{
                        'span.mdc-tab-bar__indicator': {
                            backgroundColor: styles.thirdColor,
                        },
                    }}
                />
                {this.state.examination.first_question_count === 0 ?
                    <TabBar
                        style={{ float: 'right' }}
                        activeTabIndex={this.state.mode - 1}
                        theme='indicator-accent'
                        onChange={({ target: { value } }) => this.setState({
                            mode: value + 1,
                            index: ((this.state.mode === 1 ? this.state.currentPage : this.state.currentQuestion) + 1).persian(),
                        })}>
                        <Tab>{window.gettext('Question by Question')}</Tab>
                        <Tab>{window.gettext('Page by Page')}</Tab>
                    </TabBar>
                    :

                    <span style={{ float: 'right', padding: '9px 24px' }}>
                        {this.setState({
                            mode: 1,
                            index: ((this.state.currentQuestion) + 1).persian(),
                        })}
                        {window.gettext('Question by Question')}
                    </span>

                }
                <button
                    style={{ ...styles.defaultButton, minWidth: '4em', float: 'right' }}
                    onClick={() => this.setState({ showAnswerSheet: true })}>
                    {window.gettext('Show Answer Sheet')}
                </button>
                <div id='scrollQuestion' style={{ clear: 'right', overflowY: 'visible', overflowX: 'scroll', height: 'calc(100% - 4.5em)', padding: '0px 0px' }}>{/**  overflowY: 'auto', width:'100%'  */}
                    <div className='online-exam-page'>
                        {this.renderPage()}
                    </div>
                </div>
            </div>
            <div style={{ float: 'left', clear: 'left' }}>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '2.65em 3em 3em 2.65em 2.65em',
                        gridColumnGap: '.4em',
                        marginBottom: '.5em',
                        whiteSpace: 'pre',
                        alignItems: 'center',
                    }}>
                    {previous >= 0
                        ? <button
                            style={{
                                ...styles.button,
                                minWidth: undefined,
                                height: '2.65em',
                                color: styles.thirdColor,
                                padding: 0
                            }}
                            onClick={() => this.previous_question(previous)}>
                            <i style={{ fontSize: '1.1em' }} className='fa-chevron-right' /><span style={{ color: 'black', fontSize: 10 }}>{' ' + window.gettext('Previous') + ' '}</span>
                        </button>
                        : <span style={{ minWidth: '4em', fontSize: '.9em' }}></span>
                    }
                    {this.state.mode === 1 ? window.gettext('Question') : window.gettext('Page')}:
                    <input
                        style={{
                            ...styles.input,
                            minWidth: '1em',
                            textAlign: 'center',
                            fontSize: '1em',
                        }}
                        value={this.state.index}
                        onChange={({ target: { value } }) => {
                            const index = Number(value.english());
                            if (
                                !value ||
                                index &&
                                index > 0 &&
                                index <= (this.state.mode === 1
                                    ? questions.length
                                    : _.maxBy(questions, 'page').page + 1
                                ) &&
                                (this.state.mode === 2 || questions[index - 1]/*.key*/)
                            )
                                this.setState({ index: value.persian() });
                        }}
                        onKeyPress={event => {
                            if ((event.keyCode || event.charCode) == 13)
                                (this.state.mode === 1
                                    ? this.setCurrentQuestion.bind(this)
                                    : this.setCurrentPage.bind(this)
                                )(Number(this.state.index.english()) - 1);
                        }}
                    />
                    {(
                        this.state.index &&
                        Number(this.state.index.english()) - 1 !== (this.state.mode === 1
                            ? this.state.currentQuestion
                            : this.state.currentPage
                        )
                    )
                        ? <button
                            style={{ ...styles.button, minWidth: undefined }}
                            onClick={() => (this.state.mode === 1 ? this.setCurrentQuestion.bind(this) : this.setCurrentPage).bind(this)(
                                Number(this.state.index.english()) - 1,
                            )}>
                            {window.gettext('Go')}
                        </button>
                        : <span></span>
                    }
                    {next < (this.state.mode === 1 ? questions.length : _.maxBy(questions, 'page')?.page + 1)
                        ? <button
                            style={{
                                ...styles.button,
                                minWidth: undefined,
                                height: '2.65em',
                                color: styles.thirdColor,
                                padding: 0
                            }}
                            onClick={() => this.next_question(next)}>
                            <span style={{ color: 'black', fontSize: 10 }}>{' ' + window.gettext('Next') + ' '}</span><i style={{ fontSize: '1.1em' }} className='fa-chevron-left' />
                        </button>
                        : <span style={{ minWidth: '4em', fontSize: '.9em' }}></span>
                    }
                </div>
                {/*<Tree
                    store={this.props.store.get('materialsTree')}
                    readonly
                    resource='online-examination-material'
                    multiSelection={false}
                    combobox
                    label={window.gettext('Material')}
                    staticItems={materials}
                />*/}
                {this.renderOptions()}
            </div>
        </div >;
    }
}
